import { useState, useEffect } from "react";
import EditReferrerButton from "./referrerEditReferrerButton";
import RemoveReferrerButton from "./referrerRemoveReferrerButton";

interface ReferrerTableActionsProps {
  id: number | string;
  name: string;
  lead_source: string;
  mobile_no: string;
  email: string;
  refetch: () => void;
}

const ReferrerTableActions = ({ id, name, lead_source, mobile_no, email, refetch }: ReferrerTableActionsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (isOpen) {
      timer = setTimeout(() => {
        setIsOpen(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <div className="relative">
      <button
        type="button"
        className="bg-transparent"
        onClick={() => setIsOpen(!isOpen)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
        </svg>
      </button>

      <div
        className={`absolute right-0 z-10 py-1 bg-white shadow-lg backdrop-blur-sm rounded-lg 
          ${isOpen ? "visible opacity-100" : "invisible opacity-0"}
          transition-all duration-200 min-w-[200px] -translate-y-1/2`}
        role="none"
      >
        <EditReferrerButton
          id={id}
          name={name}
          lead_source={lead_source}
          mobile_no={mobile_no}
          email={email}
          refetch={refetch}
        />
        <RemoveReferrerButton id={id} lead_source={lead_source} refetch={refetch} />
      </div>
    </div>
  );
};

export default ReferrerTableActions;